import React, { useEffect, useState } from "react";
import { Container, Card, Form, Button } from "reactstrap";
import { TiEye } from "react-icons/ti";
import { IoMdEyeOff } from "react-icons/io";
import logo from "../../assets/img/logo.png";
import { ThreeDots } from "react-loader-spinner";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { changePassword } from "../../redux/actions";
import { useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";

const ChangePassword = ({ loading, changePassword, message, error }) => {
  const [inputType1, setInputType1] = useState("password");
  const [inputType2, setInputType2] = useState("password");

  const location = useLocation();

  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm();

  const handleChangePassword = (values) => {
    const tokenAndUniqueKey = location?.pathname?.split("/")?.[3];
    const token = tokenAndUniqueKey?.split("&")?.[0]?.slice(6);
    const unique_code = tokenAndUniqueKey?.split("&")?.[1]?.slice(12);

    changePassword({ ...values, token, user_id: unique_code });
  };

  useEffect(() => {
    if (!loading && message?.length) {
      toast.success(message);
    } else if (!loading && error?.length) {
      toast.error(error);
    }
  }, [loading, error, message]);
  return (
    <div className="auth">
      <Link to="/auth/login" className="auth-logo">
        <img src={logo} alt="ontriv-logo" width="150px" />
      </Link>
      <div className="reset-password">
        <Container>
          <div className="mx-auto reset-password-wrapper">
            <div className="text-center reset-password-text">
              <h3 className="mb-0">Change Password</h3>
              <div className="mt-4 mb-5">
                <p
                  className="mb-0"
                  style={{
                    fontSize: "14px",
                    color: "#111317",
                    opacity: "0.8",
                  }}
                >
                  Your new password must be different from <br /> previously
                  used passwords
                </p>
              </div>
            </div>
            <Card className="p-5 signin-form-card ">
              <Form onSubmit={handleSubmit(handleChangePassword)}>
                <div className="password-container">
                  <div className="row">
                    {errors?.new_password && (
                      <span className="text-danger text-left">
                        Enter your password
                      </span>
                    )}
                    <div className="password-container">
                      <div className="password-icon">
                        {inputType1 === "password" ? (
                          <TiEye
                            color="#E5E9F2"
                            size="30px"
                            onClick={() => {
                              setInputType1("text");
                            }}
                          />
                        ) : (
                          <IoMdEyeOff
                            color="#000"
                            size="25px"
                            onClick={() => {
                              setInputType1("password");
                            }}
                          />
                        )}
                      </div>
                      <input
                        type={inputType1}
                        placeholder="Create new password"
                        name="new_password"
                        {...register("new_password", {
                          required: true,
                        })}
                        className={`py-3 mb- w-100 ${
                          errors.new_password ? "border-danger" : ""
                        }`}
                      />
                    </div>

                    {errors.confirm_password && (
                      <span className="text-danger text-left">
                        {errors.confirm_password?.message}
                      </span>
                    )}
                    <div className="password-container">
                      <div className="password-icon">
                        {inputType2 === "password" ? (
                          <TiEye
                            color="#E5E9F2"
                            size="30px"
                            onClick={() => {
                              setInputType2("text");
                            }}
                          />
                        ) : (
                          <IoMdEyeOff
                            color="#000"
                            size="25px"
                            onClick={() => {
                              setInputType2("password");
                            }}
                          />
                        )}
                      </div>
                      <input
                        type={inputType2}
                        name="confirm_password"
                        placeholder="Confirm password"
                        className={`py-3  w-100 ${
                          errors.confirm_password ? "border-danger" : ""
                        }`}
                        {...register("confirm_password", {
                          required: true,
                          validate: (val) => {
                            if (watch("new_password") !== val) {
                              return "Passwords do not match";
                            }
                          },
                        })}
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <Button className="py-3  mt-1" disabled={loading}>
                    {loading ? (
                      <div className="text-center w-100 align-items-center">
                        <ThreeDots
                          color="white"
                          height={"12px"}
                          wrapperStyle={{ display: "block" }}
                        />
                      </div>
                    ) : (
                      "Reset Password"
                    )}
                  </Button>
                </div>
              </Form>
            </Card>
            <div className="no-account my-4 py-4 text-center">
              <p
                className="mb-0"
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                }}
              >
                Remember Password?
                <span className="register-link">
                  <a
                    href="/auth/login"
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    {" "}
                    Login
                  </a>
                </span>
              </p>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

const mapStateToProps = ({ auth }) => {
  const { error, message, loading } = auth;
  return {
    error: error?.changePassword,
    message: message?.changePassword,
    loading: loading?.changePassword,
  };
};
export default connect(mapStateToProps, { changePassword })(ChangePassword);
